
import React from 'react';
import Layout from '@/components/Layout';
import { motion } from 'framer-motion';
import DynamicMetaTags from '@/components/DynamicMetaTags';

const About = () => {
  return (
    <Layout className="bg-gradient-to-b from-background to-muted/30">
      <DynamicMetaTags
        title="About Us - AIZen.tips"
        description="Learn about AIzen.tips, an AI discovery platform and collaborative encyclopedia where users can browse, evaluate, and discover AI solutions through visual and auditory demonstrations."
        canonical="https://aizen.tips/about"
      />
      
      <div className="container mx-auto px-4 py-24 md:py-32">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-center bg-clip-text text-transparent bg-gradient-to-r from-primary to-purple-600">
            About Us
          </h1>
          
          <div className="bg-card rounded-2xl shadow-xl border border-border p-8 md:p-10">
            <p className="text-lg mb-6 leading-relaxed text-card-foreground">
              AIzen.tips is an AI discovery platform, a collaborative encyclopedia where users can browse, evaluate, discover and get recommendations of AI solutions, all through visual and auditory demonstrations before making any commitments. Think of it as the Wikipedia of AI tools, but with a unique focus on showing exactly what each AI solution produces through images, videos, and real output examples.
            </p>
            
            <p className="text-lg mb-6 leading-relaxed text-card-foreground">
              Our mission is to empower users, from students and researchers to businesses and technology 
              enthusiasts, to explore and contribute knowledge about various AI Solutions, including advanced 
              AI models, practical tools, and innovative use cases.
            </p>
            
            <div className="my-8 border-t border-b border-border py-6">
              <p className="text-lg leading-relaxed text-card-foreground">
                This platform is proudly created and maintained by <span className="font-semibold">SimpleTechX Inc.</span>, 
                a tech company dedicated to developing innovative platforms that simplify technology access and foster global collaboration.
              </p>
            </div>
            
            <p className="text-lg italic text-center text-muted-foreground">
              Thank you for contributing to the growth of our knowledge base.
            </p>
          </div>
        </motion.div>
      </div>
    </Layout>
  );
};

export default About;
